import { render, staticRenderFns } from "./RewardPoint.vue?vue&type=template&id=f12b4792&"
import script from "./RewardPoint.vue?vue&type=script&lang=js&"
export * from "./RewardPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f12b4792')) {
      api.createRecord('f12b4792', component.options)
    } else {
      api.reload('f12b4792', component.options)
    }
    module.hot.accept("./RewardPoint.vue?vue&type=template&id=f12b4792&", function () {
      api.rerender('f12b4792', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/progressbar/Stamp/components/RewardPoint.vue"
export default component.exports